<template>
  <div class="notesSSSSS" :style="{ height: height + 'px' }">
    <div :style="{ height: ( height - 20 ) + 'px' }" class="content">
      <div class="rolling">
        <li v-for="(item,index) in info" :key="index">
          <div class="img fl"><img :src="item.avatar" width="40" height="40" alt=""></div>
          <div class="Txt fr">
            <div class="name">
              <span class="fl">{{item.username}}</span>
              <span class="fr">{{item.create_time}}前</span>
            </div>
            <div class="p">{{item.content}}
            </div>
          </div>
        </li>
      </div>
      <el-input
        type="textarea"
        class="textarea"
        placeholder="请输入内容"
        v-model="textarea">
      </el-input>
      <div @click="sure" class="sure fr">保存笔记</div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      height: {
        type: Number,
        default: 3.5
      }
    },
    data () {
      return {
        textarea: '',
        info: {}
      }
    },
    created () {
      this.getdata()
    },
    methods: {
      getdata () {
        this.$http.post('/apipx/lesson/lessonnotes', {
          lesson_id: this.$parent.id,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.info = res.data
          }
        })
      },
      sure () {
        if (this.textarea === '') {
          this.$message({
            duration: 2000,
            type: 'error',
            message: '请输入回答内容'
          })
          return false
        }
        this.$http.post('/apipx/Lesson/addnotes', {
          px_course_id: this.$parent.px_course_id,
          content: this.textarea,
          lesson_id: this.$parent.id,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.$message({
              duration: 2000,
              type: 'success',
              message: '添加成功'
            })
            this.textarea = ''
            this.getdata()
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .notesSSSSS {
    width: 360px;
    margin: 0 auto;
    overflow: hidden;

    .content {
      margin: 20px auto 0;

      .textarea {
        height: 20%;
        margin-top: 10%;

        textarea {
          height: 100%;

          &:focus {
            border: 1px solid #ff827b;
          }
        }
      }

      .rolling {
        height: 60%;
        overflow-x: hidden;
        overflow-y: scroll;

        &::-webkit-scrollbar {
          display: none;
        }

        li {
          overflow: hidden;
          margin-top: 15px;
          border-bottom: 1px solid #ebebeb;
          padding-bottom: 10px;

          &:first-child {
            margin: 0;
          }

          .img {
            width: 40px;
            height: 40px;

            img {
              border-radius: 50%;
            }
          }

          .Txt {
            width: 310px;

            .name {
              line-height: 25px;
              margin: 5px auto 0;
              width: 100%;
              height: 25px;
              overflow: hidden;

              .fl {
                font-size: 16px;
              }

              .fr {
                font-size: 14px;
                color: #b3b3b3;
              }
            }

            .p {
              font-size: 14px;
              margin: 5px auto 0;
              line-height: 30px;
            }
          }
        }
      }

      .sure {
        width: 110px;
        height: 40px;
        background-color: #ff8484;
        text-align: center;
        color: #fff;
        line-height: 40px;
        border-radius: 20px;
        cursor: pointer;
        margin: 20px 0 0 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/videoLayer/notes/notes.vue